<template>
  <div class="row">
    <page-loader
      v-if="loader"
      class="col-20"
    />
    <div
      v-else
      class="col-20 std-wrapper p-4"
    >
      <div class="row">
        <div
          v-if="messages.lenght === 0"
          class="col-20 text-center"
        >
          {{ $t('view-CampaignsMembersMessages.list-empty') }}
        </div>
        <div
          v-else
          class="col-20 col-lg-14 offset-lg-3"
        >
          <div
            v-for="message in messages"
            :key="message.id"
          >
            <message-entry
              :campaign="campaign"
              :member="member"
              :message="message"
            />
          </div>
        </div>
        <div class="col-20 col-lg-14 offset-lg-3 send-message mt-4">
          <b-form-textarea
            v-model="messageText"
            rows="4"
            max-rows="10"
          />
          <img
            :src="$publicPath + 'img/campaigns/send.svg'"
            class="send"
            @click="sendMessage"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import messageEntry from './message-partials/Entry.vue'

export default {
  components: {
    'message-entry': messageEntry
  },
  props: {
    campaign: {
      type: Object,
      default: () => { return {} }
    },
    member: {
      type: Object,
      default: () => { return {} }
    }
  },
  data: function () {
    return {
      loader: true,
      buttonLoader: false,
      messageText: '',
      readedTimeout: null,
      refreshTimeout: null
    }
  },
  computed: {
    isAdvertiser () {
      return this.$store.state.user.profile.type === 'advertiser'
    },
    messages () {
      return this.$store.state.campaignsMessages.messages[this.member.id] || []
    }
  },
  beforeMount () {
    this.loader = true

    this.$store.dispatch('campaignsMessages/getMessages', this.member.id)
      .then(() => {
        this.loader = false
      }).catch((e) => {
        this.loader = false
      })
  },
  mounted () {
    this.readedTimeout = setTimeout(() => this.markAsReaded(), 3000)
    this.refresh()
  },
  beforeDestroy () {
    if (this.readedTimeout) {
      clearTimeout(this.readedTimeout)
    }
    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout)
    }
  },
  methods: {
    sendMessage () {
      if (this.buttonLoader) {
        return
      }
      if (this.messageText === '') {
        this.$flash.error(this.$t('view-CampaignsMembersMessages.messages.empty-error'))
        return
      }
      this.buttonLoader = true

      this.$store.dispatch('campaignsMessages/addMessage', { memberId: this.member.id, message: this.messageText })
        .then(() => {
          this.$flash.success(this.$t('view-CampaignsMembersMessages.messages.success'))
          this.messageText = ''
          this.buttonLoader = false
        }).catch((e) => {
          if (e.response.status === 422) {
            this.$flash.error(this.$t(e.response.body.errors[0]))
          } else {
            this.$flash.error(this.$t('view-CampaignsMembersMessages.messages.error'))
          }
          this.buttonLoader = false
        })
    },
    markAsReaded () {
      this.$store.dispatch('campaignsMessages/markAsReaded', this.member.id)
    },
    refresh () {
      this.refreshTimeout = setTimeout(() => {
        this.$store.dispatch('campaignsMessages/getMessages', this.member.id).catch(() => {})
        this.refresh()
      }, 15000)
    }
  }
}
</script>

<style lang="scss" scoped>
  .send-message {
    position: relative;
    textarea {
      border-color: $nh-gray;
      padding-right: 2.1rem;
    }
    .send {
      position: absolute;
      bottom: 0;
      right: 10px;
      cursor: pointer;
      padding: 0.75rem;
      background-color: $warning;
      border-radius: 5px;
    }
  }
</style>
